module.exports = __webpack_public_path__ + "media/Images/PSIvet-CMYK-181468747bd4f19a163438d2cc8d7dcc.svg";